/**
 * Shared energy source options used by GeneratePDF and IncitativeConsultingFile.
 * Each entry: { value, labelKey, fallback }
 */
export const BASE_ENERGY_OPTIONS = [
  {
    value: 'hp_air',
    labelKey: 'incitative_consulting.energySource.pacAir',
    fallback: 'PAC air/eau',
  },
  {
    value: 'hp_ground',
    labelKey: 'incitative_consulting.energySource.pacSondes',
    fallback: 'PAC sol/eau',
  },
  {
    value: 'hp_water',
    labelKey: 'incitative_consulting.energySource.pacNappes',
    fallback: 'PAC eau/eau',
  },
  {
    value: 'wood_pellets',
    labelKey: 'incitative_consulting.energySource.pellets',
    fallback: 'Pellets',
  },
];

export const CAD_GENERIC = {
  value: 'district_heating_generic',
  labelKey: 'incitative_consulting.energySource.districtHeatingGeneric',
  fallback: 'CAD',
};
export const CAD_HIGH_TEMP = {
  value: 'district_heating_high_temp',
  labelKey: 'incitative_consulting.energySource.districtHeatingGeneric',
  fallback: 'CAD',
};
export const FOSSILE = {
  value: 'Fossile',
  labelKey: 'incitative_consulting.energySource.fossile',
  fallback: 'Fossile',
};

const OTHER = [
  {
    value: 'gas',
    labelKey: 'incitative_consulting.energySource.gas',
    fallback: 'Gaz',
  },
  {
    value: 'oil',
    labelKey: 'incitative_consulting.energySource.oil',
    fallback: 'Mazout',
  },
  {
    value: 'coal',
    labelKey: 'incitative_consulting.energySource.coal',
    fallback: 'Charbon',
  },

  {
    value: 'electricity',
    labelKey: 'incitative_consulting.energySource.electricity',
    fallback: 'Electricité',
  },
];

/** Options for GeneratePDF (small buildings) */
export const SMALL_BUILDING_OPTIONS = [...BASE_ENERGY_OPTIONS, CAD_GENERIC];

/** Options for IncitativeConsultingFile (large buildings) */
export const LARGE_BUILDING_OPTIONS = [
  ...BASE_ENERGY_OPTIONS,
  CAD_GENERIC,
  FOSSILE,
];

export const ALL_ENERGY_OPTIONS = [
  ...SMALL_BUILDING_OPTIONS,
  ...LARGE_BUILDING_OPTIONS,
  ...OTHER,
];
